import React, { useState, useEffect } from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink
} from 'reactstrap';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import Lib from '../../commons/lib';
import SzallitoiContent from './Szallitoi/SzallitoiContent';
import AjanlatContent from './Vevoi/AjanlatContent';
import RendelesContent from './Vevoi/RendelesContent';
import BeallitasContent from './Beallitas/BeallitasContent';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './RendelesTooltips';

const cardStyle = { padding: 10 };
const RendelesBase = (props) => {
  const { globals } = props;
  const page = globals.useQuery().get("page");

  const [tab, setTab] = useState('1');

  const location = useLocation();

  const hasRole = (roles, checkKarb) => {
    return globals.hasRole(roles, checkKarb);
  }

  const hasRoleSpec = (roles) => {
    return globals.hasRoleSpec(roles);
  }

  useEffect(() => {
    if (page) {
      setTab(page);
    } else if (hasRole(['RENDELES_AJANLAT'])) {
      setTab('1');
    } else if (hasRole(['RENDELES_VEVOI'])) {
      setTab('2');
    } else if (hasRole(['RENDELES_SZALLITOI'])) {
      setTab('3');
    } else if (hasRoleSpec(['RENDELES_BEALLITAS'])) {
      setTab('4');
    }
  }, []);

  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          Rendelés
          <CustomTooltip text={getTooltip('rendelesek')} id="rendelesekTT" />
          {/* <YouTube data={videoData} /> */}
        </div>
        <div style={cardStyle}>
          <div className="col-md-12">
            {tab && (
              <React.Fragment>
                <Nav tabs>
                  {hasRole(['RENDELES_AJANLAT']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: tab === '1' })}
                        onClick={() => setTab('1')}
                      >
                        Vevői ajánlat
                        <CustomTooltip text={getTooltip('ajanlat')} id="ajanlatTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {hasRole(['RENDELES_VEVOI']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: tab === '2' })}
                        onClick={() => setTab('2')}
                      >
                        Vevői rendelés
                        <CustomTooltip text={getTooltip('rendeles')} id="rendelesTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {hasRole(['RENDELES_SZALLITOI']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: tab === '3' })}
                        onClick={() => setTab('3')}
                      >
                        Szállítói rendelés
                        <CustomTooltip text={getTooltip('szallitoi')} id="szallitoiTT" />
                      </NavLink>
                    </NavItem>
                  )}
                  {hasRoleSpec(['RENDELES_BEALLITAS']) && (
                    <NavItem>
                      <NavLink
                        href="#"
                        className={classnames({ active: tab === '4' })}
                        onClick={() => setTab('4')}
                      >
                        Beállítások
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
                <TabContent activeTab={tab}>
                  {hasRole(['RENDELES_AJANLAT']) && (
                    <TabPane tabId="1" key={'1'}>
                      <AjanlatContent {...props} active={tab === '1'} />
                    </TabPane>
                  )}
                  {hasRole(['RENDELES_VEVOI']) && (
                    <TabPane tabId="2" key={'2'}>
                      <RendelesContent {...props} active={tab === '2'} />
                    </TabPane>
                  )}
                  {hasRole(['RENDELES_SZALLITOI']) && (
                    <TabPane tabId="3" key={'3'}>
                      <SzallitoiContent {...props} active={tab === '3'} />
                    </TabPane>
                  )}
                  {hasRoleSpec(['RENDELES_BEALLITAS']) && (
                    <TabPane tabId="4" key={'4'}>
                      <BeallitasContent {...props} active={tab === '4'} />
                    </TabPane>
                  )}
                </TabContent>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RendelesBase;
